import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import type { SitePluginPlacementConfig } from '@wix/cli-astro-definitions';
import { getSitePluginExtensionPath } from '@wix/cli-astro-definitions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { isStandaloneExtensionsProject } from '@wix/cli-custom-extensions';
import {
  getExtensionRelativePaths,
  toPosix,
} from '../utils/extension-relative-paths.js';

const SITE_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/site-plugin'
);

export async function generateSitePlugin(
  projectFolder: string,
  route: string,
  name: string,
  placements: SitePluginPlacementConfig[]
) {
  const cwd = getSitePluginExtensionPath(projectFolder, route);
  const {
    relativePathToCodeFile,
    relativePathToConfigFile,
    relativePathToExtensionDir,
  } = getExtensionRelativePaths({
    cwd,
    projectFolder,
    extensionFileName: route,
    codeFileType: 'tsx',
  });

  const relativePathToSettingsFile = `./${toPosix(
    path.join(relativePathToExtensionDir, `${route}.panel.tsx`)
  )}`;

  const config = {
    id: randomUUID(),
    name,
    placements,
    element: relativePathToCodeFile,
    settings: relativePathToSettingsFile,
  };

  const isCustomExtensionsProject =
    await isStandaloneExtensionsProject(projectFolder);

  const genResult = await componentGenerator({
    template: SITE_PLUGIN_TEMPLATE,
    assetsOutputPath: 'public',
    assetsPrefix: route,
    projectFolder,
    cwd,
    data: {
      builderPackage: isCustomExtensionsProject
        ? '@wix/custom-extensions'
        : '@wix/astro/builders',
      route,
      config,
    },
  });

  await modifyExtensionsEntry({
    projectFolder,
    extensionName: camelCase(route),
    relativePath: relativePathToConfigFile,
    isCustomExtensionsProject,
  });

  return genResult;
}
